
// import React, { useState, useEffect } from 'react';
// import { useDispatch } from 'react-redux';
// import { setUser, setGoogleUser, logout } from '../Commonlibs/userSlice';
// import { Box, Button, Checkbox, FormControlLabel, IconButton, InputAdornment, TextField, Typography, Divider, useMediaQuery, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
// import { Visibility, VisibilityOff, Phone, Email, Close, Person } from '@mui/icons-material';
// import { useTheme } from '@mui/material/styles';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import Loader from '../Loader/Loader';
// import proptitle from '../assets/titleprop.png';
// import googleIcon from '../assets/google.png';
// import lockIcon from '../assets/lock.png';
// import { persistor } from '../Commonlibs/store';
// import tited from '../assets/tited.png';

// const Login = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const [loading, setLoading] = useState(false);
  
//   // State to toggle between Google and Phone login views
//   const [showPhoneLogin, setShowPhoneLogin] = useState(false);
  
//   // Phone number related states
//   const [phoneNumber, setPhoneNumber] = useState('');
//   const [showOtpInput, setShowOtpInput] = useState(false);
//   const [otp, setOtp] = useState('');
//   const [dialog, setDialog] = useState({ open: false, title: '', message: '', severity: 'info' });
  
//   // State for OTP popup
//   const [otpPopup, setOtpPopup] = useState({ open: false, otp: '' });

//   // FORCE GOOGLE LOGIN VIEW ON COMPONENT MOUNT
//   useEffect(() => {
//     setShowPhoneLogin(false);
//     setShowOtpInput(false);
//     setOtp('');
//     setPhoneNumber('');
//   }, []);

//   // Clear any residual authentication data when login page loads
//   useEffect(() => {
//     const clearResidualAuth = () => {
//       const token = localStorage.getItem('auth_token');
//       if (!token) {
//         localStorage.removeItem('auth_token');
//         localStorage.removeItem('user_id');
//         localStorage.removeItem('user_email');
//         localStorage.removeItem('user_name');
//       }
//     };
//     clearResidualAuth();
//   }, []);

//   // UPDATED: Enhanced Google OAuth redirect response handler
//   useEffect(() => {
//     const processGoogleResponse = async () => {
//       try {
//         const hashParams = new URLSearchParams(location.hash.substring(1));
//         const searchParams = new URLSearchParams(location.search);
        
//         console.log('Checking for OAuth response...');
//         console.log('Hash params:', location.hash);
//         console.log('Search params:', location.search);

//         const responseData = hashParams.get('response') || searchParams.get('response');
//         const token = hashParams.get('token') || searchParams.get('token');
//         const userId = hashParams.get('id') || searchParams.get('id') || searchParams.get('user_id');

//         if (responseData) {
//           console.log('Found response data in URL');
//           const parsedResponse = JSON.parse(decodeURIComponent(responseData));
//           console.log('Parsed Google response:', parsedResponse);

//           if (parsedResponse.statusCode === 200 && parsedResponse.status === "SUCCESS") {
//             const userData = parsedResponse.result;
            
//             if (userData.token) {
//               localStorage.setItem('auth_token', userData.token);
//               console.log('Token stored:', userData.token);
//             }

//             if (userData.id) {
//               await fetchAndSetUserProfile(userData.id, userData.token || localStorage.getItem('auth_token'));
//             } else {
//               console.log('No user ID found, using userData directly');
//               handleDirectUserData(userData);
//             }
//           } else {
//             console.error('OAuth response not successful:', parsedResponse);
//             showDialog('Error', parsedResponse.message || 'Google login failed', 'error');
//           }
//         } else if (token && userId) {
//           console.log('Found token and userId in URL params');
//           localStorage.setItem('auth_token', token);
//           await fetchAndSetUserProfile(userId, token);
//         }

//         if (responseData || token) {
//           console.log('Cleaning URL...');
//           window.history.replaceState({}, document.title, '/login');
//         }
//       } catch (error) {
//         console.error('Error processing Google OAuth response:', error);
//         showDialog('Error', 'Failed to process Google login. Please try again.', 'error');
//         setLoading(false);
//       }
//     };

//     const handleDirectUserData = (userData) => {
//       try {
//         const userToStore = {
//           id: userData.id,
//           fullName: userData.full_name || userData.fullName,
//           email: userData.email_id || userData.email,
//           contactNumber: userData.contact_number || userData.contactNumber,
//           token: userData.token || localStorage.getItem('auth_token'),
//           authProvider: userData.auth_provider || 'google',
//           googleId: userData.google_id,
//           profileImage: userData.profile_image,
//         };

//         localStorage.setItem('auth_token', userToStore.token);
//         localStorage.setItem('user_id', userToStore.id.toString());
//         localStorage.setItem('user_email', userToStore.email);
//         localStorage.setItem('user_name', userToStore.fullName);

//         dispatch(setGoogleUser(userToStore));
//         setLoading(true);
//         setTimeout(() => {
//           navigate('/sell-properties');
//         }, 1500);
//       } catch (error) {
//         console.error('Error handling direct user data:', error);
//         showDialog('Error', 'Failed to process user data', 'error');
//       }
//     };

//     const fetchAndSetUserProfile = async (userId, token) => {
//       try {
//         setLoading(true);
//         dispatch(logout());
//         await persistor.purge();

//         console.log('Fetching user profile for ID:', userId);
//         const response = await fetch(
//           `https://propertydealstalk.com/api/users/getUserById?user_id=${userId}`,
//           {
//             method: 'GET',
//             headers: {
//               'Authorization': `Bearer ${token}`,
//               'Content-Type': 'application/json'
//             }
//           }
//         );

//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }

//         const data = await response.json();
//         console.log('User profile API response:', data);

//         if (data.status === "SUCCESS" && data.result) {
//           const userProfile = data.result;

//           const userToStore = {
//             id: userProfile.id,
//             fullName: userProfile.full_name,
//             email: userProfile.email_id,
//             contactNumber: userProfile.contact_number,
//             token: token,
//             authProvider: userProfile.auth_provider,
//             googleId: userProfile.google_id,
//             profileImage: userProfile.profile_image,
//             location: userProfile.location,
//             occupation: userProfile.occupation,
//             professionalTitle: userProfile.professional_title,
//             companyName: userProfile.company_name,
//             yearsOfExperience: userProfile.years_of_experience,
//             licenseNumber: userProfile.license_number,
//             bio: userProfile.bio,
//             website: userProfile.website,
//             linkedin: userProfile.linkedin,
//             facebook: userProfile.facebook,
//           };

//           localStorage.setItem('auth_token', token);
//           localStorage.setItem('user_id', userProfile.id.toString());
//           localStorage.setItem('user_email', userProfile.email_id);
//           localStorage.setItem('user_name', userProfile.full_name);

//           if (userProfile.auth_provider === 'google') {
//             dispatch(setGoogleUser(userToStore));
//           } else {
//             dispatch(setUser(userToStore));
//           }

//           setTimeout(() => {
//             navigate('/sell-properties');
//             setLoading(false);
//           }, 1500);
//         } else {
//           throw new Error(data.message || 'Failed to fetch user profile');
//         }
//       } catch (error) {
//         console.error('Error fetching user profile:', error);
//         showDialog('Error', `Failed to fetch user profile: ${error.message}`, 'error');
//         setLoading(false);
//       }
//     };

//     if (location.search || location.hash) {
//       processGoogleResponse();
//     }
//   }, [location.search, location.hash, dispatch, navigate]);

//   const handleCloseDialog = () => {
//     setDialog({...dialog, open: false});
//   };

//   const showDialog = (title, message, severity = 'info') => {
//     setDialog({ open: true, title, message, severity });
//   };

//   const handlePhoneNumberChange = (e) => {
//     const value = e.target.value;
//     if (value === '' || (/^\d+$/.test(value) && value.length <= 10)) {
//       setPhoneNumber(value);
//     }
//   };

//   const handleOtpChange = (e) => {
//     const value = e.target.value;
//     if (value === '' || (/^\d+$/.test(value) && value.length <= 6)) {
//       setOtp(value);
//     }
//   };

//   const handleGoogleLogin = async () => {
//     try {
//       localStorage.removeItem('auth_token');
//       localStorage.removeItem('user_id');
//       localStorage.removeItem('user_email');
//       localStorage.removeItem('user_name');
//       await persistor.purge();
//       setLoading(true);
//       window.location.href = 'https://propertydealstalk.com/api/users/auth/google/start';
//     } catch (error) {
//       console.error('Error initiating Google login:', error);
//       setLoading(false);
//     }
//   };

//   const handleGetOTP = async () => {
//     if (phoneNumber.length !== 10) {
//       showDialog('Error', 'Please enter a valid 10-digit phone number.', 'error');
//       return;
//     }

//     setLoading(true);
//     try {
//       const response = await fetch('https://propertydealstalk.com/api/users/requestMobileOtp', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ contact_number: phoneNumber }),
//       });

//       const data = await response.json();

//       if (response.ok && data.status === "SUCCESS") {
//         setOtpPopup({ open: true, otp: data.result.otp });
//         setShowOtpInput(true);
//       } else {
//         showDialog('Error', data.message || 'Failed to send OTP. Please try again.', 'error');
//       }
//     } catch (error) {
//       console.error('OTP request error:', error);
//       showDialog('Error', 'Something went wrong. Please try again later.', 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCloseOtpPopup = () => {
//     setOtp(otpPopup.otp);
//     setOtpPopup({ open: false, otp: '' });
//   };

//   const handleVerifyOtp = async () => {
//     if (otp.length < 4) {
//       showDialog('Error', 'Please enter a valid OTP.', 'error');
//       return;
//     }

//     setLoading(true);
//     try {
//       const response = await fetch('https://propertydealstalk.com/api/users/verifyMobileOtp', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ contact_number: phoneNumber, otp: otp }),
//       });

//       const data = await response.json();

//       if (response.ok && data.status === "SUCCESS") {
//         const userData = data.result;

//         const userToStore = {
//           id: userData.id,
//           fullName: userData.full_name,
//           email: userData.email_id,
//           contactNumber: userData.contact_number,
//           token: userData.token
//         };

//         localStorage.setItem('auth_token', userData.token);
//         localStorage.setItem('user_id', userData.id);
//         localStorage.setItem('user_email', userData.email_id);

//         dispatch(setUser(userToStore));

//         setTimeout(() => {
//           navigate('/sell-properties');
//           setLoading(false);
//         }, 1500);
//       } else {
//         setLoading(false);
//         showDialog('Error', data.message || 'Invalid OTP. Please try again.', 'error');
//       }
//     } catch (error) {
//       console.error('OTP verification error:', error);
//       setLoading(false);
//       showDialog('Error', 'Something went wrong. Please try again later.', 'error');
//     }
//   };

//   const handleToggleLoginMethod = () => {
//     setShowPhoneLogin(!showPhoneLogin);
//     if (showPhoneLogin) {
//       setShowOtpInput(false);
//       setOtp('');
//       setPhoneNumber('');
//     }
//   };

//   return (
//     <Box
//       display="flex"
//       flexDirection={isMobile ? 'column' : 'row'}
//       sx={{ width: '100%', height: '100vh', overflow: 'hidden' }}
//     >
//       <Dialog
//         open={dialog.open}
//         onClose={handleCloseDialog}
//         aria-labelledby="alert-dialog-title"
//         aria-describedby="alert-dialog-description"
//         PaperProps={{ style: { borderRadius: '8px', width:'400px', height:'120px' } }}
//       >
//         <DialogTitle
//           id="alert-dialog-title"
//           sx={{
//             textAlign: 'center',
//             color: dialog.severity === 'success' ? '#4caf50' : dialog.severity === 'error' ? '#f44336' : '#0052ff',
//             fontWeight: 500,
//             pt: 3
//           }}
//         >
//           {dialog.title}
//         </DialogTitle>
//         <DialogContent sx={{ pb: 3 }}>
//           <DialogContentText id="alert-dialog-description" sx={{ textAlign: 'center' }}>
//             {dialog.message}
//           </DialogContentText>
//         </DialogContent>
//       </Dialog>

//       {/* OTP Popup Dialog */}
//       <Dialog
//         open={otpPopup.open}
//         onClose={handleCloseOtpPopup}
//         aria-labelledby="otp-dialog-title"
//         PaperProps={{ style: { borderRadius: '8px', width: '400px', position: 'absolute', top: '20px' } }}
//       >
//         <DialogTitle
//           id="otp-dialog-title"
//           sx={{ textAlign: 'center', color: '#0052ff', fontWeight: 500, pt: 3 }}
//         >
//           Your OTP
//         </DialogTitle>
//         <DialogContent sx={{ pb: 2 }}>
//           <DialogContentText sx={{ textAlign: 'center', fontSize: '24px', fontWeight: 'bold', color: '#000' }}>
//             {otpPopup.otp}
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
//           <Button
//             onClick={handleCloseOtpPopup}
//             variant="contained"
//             sx={{
//               bgcolor: '#0052ff',
//               color: '#fff',
//               px: 4,
//               py: 1,
//               fontWeight: 500,
//               borderRadius: 2,
//               textTransform: 'none',
//               '&:hover': { bgcolor: '#0041cc' }
//             }}
//           >
//             OK
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {loading && <Loader />}

//       {/* LEFT SIDE */}
//       <Box
//         width={isMobile ? '100%' : '40%'}
//         height={isMobile ? '30vh' : '100%'}
//         display="flex"
//         flexDirection="column"
//         justifyContent="center"
//         alignItems="center"
//         sx={{
//           backgroundColor: '#AA16FF1A',
//           padding: 4,
//           position: 'relative',
//         }}
//       >
//         <Box
//           sx={{
//             display: 'flex',
//             flexDirection: 'column',
//             justifyContent: 'center',
//             alignItems: 'center',
//             gap: 2,
//           }}
//         >
//           <img
//             src={tited}
//             alt="PropertyDealsTalk.com"
//             style={{
//               width: isMobile ? '280px' : '400px',
//               height: 'auto',
//               objectFit: 'contain'
//             }}
//           />
//         </Box>
//       </Box>

//       {/* RIGHT SIDE - LOGIN FORM */}
//       <Box
//         sx={{
//           width: isMobile ? '100%' : '60%',
//           height: isMobile ? 'calc(100vh - 30vh)' : '100%',
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'center',
//           alignItems: 'center',
//           backgroundColor: '#fff',
//           px: { xs: 2, sm: 3 },
//           py: { xs: 2, sm: 3 },
//           overflowY: isMobile ? 'auto' : 'hidden',
//           boxSizing: 'border-box',
//         }}
//       >
//         <Box
//           sx={{
//             width: '100%',
//             maxWidth: 320,
//             borderRadius: 3,
//             p: { xs: 2, sm: 3 },
//             boxShadow: '0 0 20px rgba(0,0,0,0.05)',
//             border: '1px solid #eee',
//             mb: 2,
//             mx: 'auto',
//           }}
//         >
//           {!showPhoneLogin ? (
//             <>
//               {/* GOOGLE LOGIN VIEW (PRIMARY) */}
              
//               {/* Continue with - Bordered Box replacing Divider */}
//               <Box
//                 sx={{
//                   border: '1px solid #ccc',
//                   borderRadius: 2,
//                   p: 2,
//                   my: 2,
//                   position: 'relative'
//                 }}
//               >
//                 <Typography
//                   sx={{
//                     position: 'absolute',
//                     top: -12,
//                     left: '50%',
//                     transform: 'translateX(-50%)',
//                     bgcolor: '#fff',
//                     px: 2,
//                     color: '#536686',
//                     fontSize: '13px'
//                   }}
//                 >
//                   Continue with
//                 </Typography>

//                 <Button
//                   fullWidth
//                   variant="contained"
//                   startIcon={<img src={googleIcon} alt="Google" style={{ width: 18 }} />}
//                   onClick={handleGoogleLogin}
//                   sx={{
//                     bgcolor: '#0052ff',
//                     color: '#fff',
//                     py: 1.2,
//                     fontWeight: 500,
//                     borderRadius: 2,
//                     textTransform: 'none',
//                     mb: 0.5
//                   }}
//                 >
//                   Continue with Google
//                 </Button>

//                 <Divider
//                   sx={{
//                     my: 1,
//                     '&::before, &::after': { borderColor: '#ccc' },
//                     color: '#536686',
//                     fontSize: '13px'
//                   }}
//                 >
//                   Or
//                 </Divider>

//                 <Button
//                   fullWidth
//                   variant="contained"
//                   startIcon={<Phone sx={{ width: 18, height: 18, color: '#fff' }} />}
//                   onClick={handleToggleLoginMethod}
//                   sx={{
//                     bgcolor: '#0052ff',
//                     color: '#fff',
//                     py: 1.2,
//                     fontWeight: 500,
//                     borderRadius: 2,
//                     textTransform: 'none'
//                   }}
//                 >
//                   Continue with Phone Number
//                 </Button>
//               </Box>

//               {/* Don't have an account - Bordered Box replacing Divider */}
//               <Box
//                 sx={{
//                   border: '1px solid #ccc',
//                   borderRadius: 2,
//                   p: 2,
//                   my: 2,
//                   position: 'relative'
//                 }}
//               >
//                 <Typography
//                   sx={{
//                     position: 'absolute',
//                     top: -12,
//                     left: '50%',
//                     transform: 'translateX(-50%)',
//                     bgcolor: '#fff',
//                     px: 2,
//                     color: '#536686',
//                     fontSize: '13px',
//                     whiteSpace: 'nowrap'
//                   }}
//                 >
//                   Don't have an account, Signup
//                 </Typography>

//                 <Button
//                   fullWidth
//                   variant="outlined"
//                   startIcon={<Person sx={{ width: 18, height: 18, color: '#536686' }} />}
//                   onClick={() => navigate('/register')}
//                   sx={{
//                     borderRadius: 2,
//                     textTransform: 'none',
//                     fontWeight: 500,
//                     pt: 1.2,
//                     pb: 1.2,
//                     fontSize: '0.9rem',
//                     borderColor: '#536686',
//                     color: '#536686',
//                     '&:hover': {
//                       borderColor: '#0052ff',
//                       backgroundColor: 'rgba(0, 82, 255, 0.04)'
//                     }
//                   }}
//                 >
//                   Create an Account
//                 </Button>
//               </Box>
//             </>
//           ) : (
//             <>
//               {/* PHONE LOGIN VIEW */}
//               <Typography variant="subtitle2" sx={{ mb: 0.5 }}>Phone Number</Typography>
//               <TextField
//                 fullWidth
//                 placeholder="Enter your phone number"
//                 margin="dense"
//                 value={phoneNumber}
//                 onChange={handlePhoneNumberChange}
//                 disabled={showOtpInput}
//                 sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px', } }}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Phone sx={{ width: 18, height: 18, mr: 1, color: '#536686' }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 inputProps={{ maxLength: 10, pattern: '[0-9]*' }}
//               />

//               {showOtpInput && (
//                 <>
//                   <Typography variant="subtitle2" sx={{ mt: 1.5, mb: 0.5 }}>OTP</Typography>
//                   <TextField
//                     fullWidth
//                     placeholder="Enter OTP"
//                     margin="dense"
//                     value={otp}
//                     onChange={handleOtpChange}
//                     sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px', } }}
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <img src={lockIcon} alt="lock" style={{ width: 18, marginRight: 10 }} />
//                         </InputAdornment>
//                       ),
//                     }}
//                     inputProps={{ maxLength: 6, pattern: '[0-9]*' }}
//                   />
//                 </>
//               )}

//               <Box display="flex" justifyContent="space-between" alignItems="center" mt={1.5} mb={2} flexWrap="wrap">
//                 <FormControlLabel
//                   control={<Checkbox size="small" />}
//                   label="Remember me"
//                   sx={{ '& .MuiFormControlLabel-label': { color: '#536686', fontSize: { xs: '12px', sm: '13px' } }, }}
//                 />
//                 {showOtpInput && (
//                   <Typography
//                     component="span"
//                     onClick={handleGetOTP}
//                     sx={{ fontSize: { xs: '12px', sm: '13px' }, color: '#0052ff', textDecoration: 'none', cursor: 'pointer' }}
//                   >
//                     Resend OTP
//                   </Typography>
//                 )}
//               </Box>

//               <Button
//                 variant="contained"
//                 fullWidth
//                 disabled={loading || (showOtpInput ? otp.length < 4 : phoneNumber.length !== 10)}
//                 onClick={showOtpInput ? handleVerifyOtp : handleGetOTP}
//                 sx={{ bgcolor: '#0052ff', color: '#fff', py: 1.2, fontWeight: 500, borderRadius: 2, textTransform: 'none', mb: 2 }}
//               >
//                 {showOtpInput ? 'Login with OTP' : 'Get OTP'}
//               </Button>

//               <Divider
//                 sx={{ my: 2, '&::before, &::after': { borderColor: '#ccc' }, color: '#536686', fontSize: '13px' }}
//               >
//                 Or connect with
//               </Divider>

//               <Button
//                 fullWidth
//                 variant="outlined"
//                 startIcon={<img src={googleIcon} alt="Google" style={{ width: 18 }} />}
//                 onClick={handleToggleLoginMethod}
//                 sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 500, pt: 1.2, pb: 1.2, fontSize: '0.9rem' }}
//               >
//                 Google
//               </Button>
//             </>
//           )}
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default Login;


import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setUser, setGoogleUser, logout } from '../Commonlibs/userSlice';
import { Box, Button, Checkbox, FormControlLabel, IconButton, InputAdornment, TextField, Typography, Divider, useMediaQuery, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { Visibility, VisibilityOff, Phone, Email, Close, Person } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Loader from '../Loader/Loader';
import proptitle from '../assets/titleprop.png';
import googleIcon from '../assets/google.png';
import lockIcon from '../assets/lock.png';
import { persistor } from '../Commonlibs/store';
import tited from '../assets/tited.png';
import propmenu from '../assets/menugroup.png';
import home from '../assets/lob.png';

const Login = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  
  // State to toggle between Google and Phone login views
  const [showPhoneLogin, setShowPhoneLogin] = useState(false);
  
  // Phone number related states
  const [phoneNumber, setPhoneNumber] = useState('');
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otp, setOtp] = useState('');
  const [dialog, setDialog] = useState({ open: false, title: '', message: '', severity: 'info' });
  
  // State for OTP popup
  const [otpPopup, setOtpPopup] = useState({ open: false, otp: '' });

  // FORCE GOOGLE LOGIN VIEW ON COMPONENT MOUNT
  useEffect(() => {
    setShowPhoneLogin(false);
    setShowOtpInput(false);
    setOtp('');
    setPhoneNumber('');
  }, []);

  // Clear any residual authentication data when login page loads
  useEffect(() => {
    const clearResidualAuth = () => {
      const token = localStorage.getItem('auth_token');
      if (!token) {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user_id');
        localStorage.removeItem('user_email');
        localStorage.removeItem('user_name');
      }
    };
    clearResidualAuth();
  }, []);

  // ✅ Enhanced: Handle property data preservation after login
  useEffect(() => {
    const returnTo = location.state?.returnTo;
    const preserveData = location.state?.preserveData;
    
    // Check if user just logged in and needs to return to property flow
    const checkLoginAndRedirect = () => {
      const token = localStorage.getItem('auth_token');
      const userId = localStorage.getItem('user_id');
      
      if (token && userId && returnTo && preserveData) {
        // Check if user has property data saved
        const hasPropertyData = localStorage.getItem('propertyDetailsFormState') || 
                               localStorage.getItem('propertyImagePreviews') ||
                               localStorage.getItem('propertyType') ||
                               localStorage.getItem('category') ||
                               localStorage.getItem('price_askingPrice') ||
                               localStorage.getItem('rent_monthlyRent');
        
        if (hasPropertyData) {
          console.log('🔄 Returning to property flow with preserved data');
          
          // Navigate back to property flow with preserved data
          setTimeout(() => {
            navigate(returnTo, { 
              state: { 
                continueFromLogin: true,
                preserveImages: true,
                fromBackNavigation: false,
                ...location.state
              },
              replace: true
            });
          }, 500);
        }
      }
    };

    checkLoginAndRedirect();
  }, [location.state, navigate]);

  // UPDATED: Enhanced Google OAuth redirect response handler
  useEffect(() => {
    const processGoogleResponse = async () => {
      try {
        const hashParams = new URLSearchParams(location.hash.substring(1));
        const searchParams = new URLSearchParams(location.search);
        
        console.log('Checking for OAuth response...');
        console.log('Hash params:', location.hash);
        console.log('Search params:', location.search);

        const responseData = hashParams.get('response') || searchParams.get('response');
        const token = hashParams.get('token') || searchParams.get('token');
        const userId = hashParams.get('id') || searchParams.get('id') || searchParams.get('user_id');

        if (responseData) {
          console.log('Found response data in URL');
          const parsedResponse = JSON.parse(decodeURIComponent(responseData));
          console.log('Parsed Google response:', parsedResponse);

          if (parsedResponse.statusCode === 200 && parsedResponse.status === "SUCCESS") {
            const userData = parsedResponse.result;
            
            if (userData.token) {
              localStorage.setItem('auth_token', userData.token);
              console.log('Token stored:', userData.token);
            }

            if (userData.id) {
              await fetchAndSetUserProfile(userData.id, userData.token || localStorage.getItem('auth_token'));
            } else {
              console.log('No user ID found, using userData directly');
              handleDirectUserData(userData);
            }
          } else {
            console.error('OAuth response not successful:', parsedResponse);
            showDialog('Error', parsedResponse.message || 'Google login failed', 'error');
          }
        } else if (token && userId) {
          console.log('Found token and userId in URL params');
          localStorage.setItem('auth_token', token);
          await fetchAndSetUserProfile(userId, token);
        }

        if (responseData || token) {
          console.log('Cleaning URL...');
          window.history.replaceState({}, document.title, '/login');
        }
      } catch (error) {
        console.error('Error processing Google OAuth response:', error);
        showDialog('Error', 'Failed to process Google login. Please try again.', 'error');
        setLoading(false);
      }
    };

    const handleDirectUserData = (userData) => {
      try {
        const userToStore = {
          id: userData.id,
          fullName: userData.full_name || userData.fullName,
          email: userData.email_id || userData.email,
          contactNumber: userData.contact_number || userData.contactNumber,
          token: userData.token || localStorage.getItem('auth_token'),
          authProvider: userData.auth_provider || 'google',
          googleId: userData.google_id,
          profileImage: userData.profile_image,
        };

        localStorage.setItem('auth_token', userToStore.token);
        localStorage.setItem('user_id', userToStore.id.toString());
        localStorage.setItem('user_email', userToStore.email);
        localStorage.setItem('user_name', userToStore.fullName);

        dispatch(setGoogleUser(userToStore));
        setLoading(true);
        
        // ✅ Check if returning to property flow
        const returnTo = location.state?.returnTo;
        const preserveData = location.state?.preserveData;
        
        setTimeout(() => {
          if (returnTo && preserveData) {
            navigate(returnTo, { 
              state: { 
                continueFromLogin: true,
                preserveImages: true,
                ...location.state
              } 
            });
          } else {
            navigate('/sell-properties');
          }
        }, 1500);
      } catch (error) {
        console.error('Error handling direct user data:', error);
        showDialog('Error', 'Failed to process user data', 'error');
      }
    };

    const fetchAndSetUserProfile = async (userId, token) => {
      try {
        setLoading(true);
        dispatch(logout());
        await persistor.purge();

        console.log('Fetching user profile for ID:', userId);
        const response = await fetch(
          `https://propertydealstalk.com/api/users/getUserById?user_id=${userId}`,
          {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log('User profile API response:', data);

        if (data.status === "SUCCESS" && data.result) {
          const userProfile = data.result;

          const userToStore = {
            id: userProfile.id,
            fullName: userProfile.full_name,
            email: userProfile.email_id,
            contactNumber: userProfile.contact_number,
            token: token,
            authProvider: userProfile.auth_provider,
            googleId: userProfile.google_id,
            profileImage: userProfile.profile_image,
            location: userProfile.location,
            occupation: userProfile.occupation,
            professionalTitle: userProfile.professional_title,
            companyName: userProfile.company_name,
            yearsOfExperience: userProfile.years_of_experience,
            licenseNumber: userProfile.license_number,
            bio: userProfile.bio,
            website: userProfile.website,
            linkedin: userProfile.linkedin,
            facebook: userProfile.facebook,
          };

          localStorage.setItem('auth_token', token);
          localStorage.setItem('user_id', userProfile.id.toString());
          localStorage.setItem('user_email', userProfile.email_id);
          localStorage.setItem('user_name', userProfile.full_name);

          if (userProfile.auth_provider === 'google') {
            dispatch(setGoogleUser(userToStore));
          } else {
            dispatch(setUser(userToStore));
          }

          // ✅ Check if returning to property flow
          const returnTo = location.state?.returnTo;
          const preserveData = location.state?.preserveData;

          setTimeout(() => {
            if (returnTo && preserveData) {
              navigate(returnTo, { 
                state: { 
                  continueFromLogin: true,
                  preserveImages: true,
                  ...location.state
                } 
              });
            } else {
              navigate('/sell-properties');
            }
            setLoading(false);
          }, 1500);
        } else {
          throw new Error(data.message || 'Failed to fetch user profile');
        }
      } catch (error) {
        console.error('Error fetching user profile:', error);
        showDialog('Error', `Failed to fetch user profile: ${error.message}`, 'error');
        setLoading(false);
      }
    };

    if (location.search || location.hash) {
      processGoogleResponse();
    }
  }, [location.search, location.hash, dispatch, navigate, location.state]);

  const handleCloseDialog = () => {
    setDialog({...dialog, open: false});
  };

  const showDialog = (title, message, severity = 'info') => {
    setDialog({ open: true, title, message, severity });
  };

  const handlePhoneNumberChange = (e) => {
    const value = e.target.value;
    if (value === '' || (/^\d+$/.test(value) && value.length <= 10)) {
      setPhoneNumber(value);
    }
  };

  const handleOtpChange = (e) => {
    const value = e.target.value;
    if (value === '' || (/^\d+$/.test(value) && value.length <= 6)) {
      setOtp(value);
    }
  };

  const handleGoogleLogin = async () => {
    try {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user_id');
      localStorage.removeItem('user_email');
      localStorage.removeItem('user_name');
      await persistor.purge();
      setLoading(true);
      window.location.href = 'https://propertydealstalk.com/api/users/auth/google/start';
    } catch (error) {
      console.error('Error initiating Google login:', error);
      setLoading(false);
    }
  };

  const handleGetOTP = async () => {
    if (phoneNumber.length !== 10) {
      showDialog('Error', 'Please enter a valid 10-digit phone number.', 'error');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch('https://propertydealstalk.com/api/users/requestMobileOtp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ contact_number: phoneNumber }),
      });

      const data = await response.json();

      if (response.ok && data.status === "SUCCESS") {
        setOtpPopup({ open: true, otp: data.result.otp });
        setShowOtpInput(true);
      } else {
        showDialog('Error', data.message || 'Failed to send OTP. Please try again.', 'error');
      }
    } catch (error) {
      console.error('OTP request error:', error);
      showDialog('Error', 'Something went wrong. Please try again later.', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleCloseOtpPopup = () => {
    setOtp(otpPopup.otp);
    setOtpPopup({ open: false, otp: '' });
  };

  const handleVerifyOtp = async () => {
    if (otp.length < 4) {
      showDialog('Error', 'Please enter a valid OTP.', 'error');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch('https://propertydealstalk.com/api/users/verifyMobileOtp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ contact_number: phoneNumber, otp: otp }),
      });

      const data = await response.json();

      if (response.ok && data.status === "SUCCESS") {
        const userData = data.result;

        const userToStore = {
          id: userData.id,
          fullName: userData.full_name,
          email: userData.email_id,
          contactNumber: userData.contact_number,
          token: userData.token
        };

        localStorage.setItem('auth_token', userData.token);
        localStorage.setItem('user_id', userData.id);
        localStorage.setItem('user_email', userData.email_id);

        dispatch(setUser(userToStore));

        // ✅ Check if returning to property flow
        const returnTo = location.state?.returnTo;
        const preserveData = location.state?.preserveData;

        setTimeout(() => {
          if (returnTo && preserveData) {
            navigate(returnTo, { 
              state: { 
                continueFromLogin: true,
                preserveImages: true,
                ...location.state
              } 
            });
          } else {
            navigate('/sell-properties');
          }
          setLoading(false);
        }, 1500);
      } else {
        setLoading(false);
        showDialog('Error', data.message || 'Invalid OTP. Please try again.', 'error');
      }
    } catch (error) {
      console.error('OTP verification error:', error);
      setLoading(false);
      showDialog('Error', 'Something went wrong. Please try again later.', 'error');
    }
  };

  const handleToggleLoginMethod = () => {
    setShowPhoneLogin(!showPhoneLogin);
    if (showPhoneLogin) {
      setShowOtpInput(false);
      setOtp('');
      setPhoneNumber('');
    }
  };

  return (
    <Box
      display="flex"
      flexDirection={isMobile ? 'column' : 'row'}
      sx={{ width: '100%', height: '100vh', overflow: 'hidden' }}
    >
      <Dialog
        open={dialog.open}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ style: { borderRadius: '8px', width:'400px', height:'120px' } }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            textAlign: 'center',
            color: dialog.severity === 'success' ? '#4caf50' : dialog.severity === 'error' ? '#f44336' : '#0052ff',
            fontWeight: 500,
            pt: 3
          }}
        >
          {dialog.title}
        </DialogTitle>
        <DialogContent sx={{ pb: 3 }}>
          <DialogContentText id="alert-dialog-description" sx={{ textAlign: 'center' }}>
            {dialog.message}
          </DialogContentText>
        </DialogContent>
      </Dialog>

      {/* OTP Popup Dialog */}
      <Dialog
        open={otpPopup.open}
        onClose={handleCloseOtpPopup}
        aria-labelledby="otp-dialog-title"
        PaperProps={{ style: { borderRadius: '8px', width: '400px', position: 'absolute', top: '20px' } }}
      >
        <DialogTitle
          id="otp-dialog-title"
          sx={{ textAlign: 'center', color: '#0052ff', fontWeight: 500, pt: 3 }}
        >
          Your OTP
        </DialogTitle>
        <DialogContent sx={{ pb: 2 }}>
          <DialogContentText sx={{ textAlign: 'center', fontSize: '24px', fontWeight: 'bold', color: '#000' }}>
            {otpPopup.otp}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
          <Button
            onClick={handleCloseOtpPopup}
            variant="contained"
            sx={{
              bgcolor: '#0052ff',
              color: '#fff',
              px: 4,
              py: 1,
              fontWeight: 500,
              borderRadius: 2,
              textTransform: 'none',
              '&:hover': { bgcolor: '#0041cc' }
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      {loading && <Loader />}

      {/* LEFT SIDE */}
      <Box
        width={isMobile ? '100%' : '40%'}
        height={isMobile ? '30vh' : '100%'}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        sx={{
          backgroundColor: '#AA16FF1A',
          padding: 4,
          position: 'relative',
        }}
      >
        <Box
          sx={{
            display: 'flex',
             flexDirection: 'row', 
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2,
          }}
        >

           <img
            src={home}
            alt="Home"
            style={{
              width: isMobile ? '80px' : '100px',
              height: 'auto',
              objectFit: 'contain'
            }}
          />

          <img
            src={propmenu}
            alt="PropertyDealsTalk.com"
            style={{
              width: isMobile ? '280px' : '400px',
              height: 'auto',
              objectFit: 'contain'
            }}
          />
        </Box>
      </Box>

      {/* RIGHT SIDE - LOGIN FORM */}
      <Box
        sx={{
          width: isMobile ? '100%' : '60%',
          height: isMobile ? 'calc(100vh - 30vh)' : '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#fff',
          px: { xs: 2, sm: 3 },
          py: { xs: 2, sm: 3 },
          overflowY: isMobile ? 'auto' : 'hidden',
          boxSizing: 'border-box',
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: 320,
            borderRadius: 3,
            p: { xs: 2, sm: 3 },
            boxShadow: '0 0 20px rgba(0,0,0,0.05)',
            border: '1px solid #eee',
            mb: 2,
            mx: 'auto',
          }}
        >
          {!showPhoneLogin ? (
            <>
              {/* GOOGLE LOGIN VIEW (PRIMARY) */}
              
              {/* Continue with - Bordered Box replacing Divider */}
              <Box
                sx={{
                  border: '1px solid #ccc',
                  borderRadius: 2,
                  p: 2,
                  my: 2,
                  position: 'relative'
                }}
              >
                <Typography
                  sx={{
                    position: 'absolute',
                    top: -12,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    bgcolor: '#fff',
                    px: 2,
                    color: '#536686',
                    fontSize: '13px'
                  }}
                >
                  Continue with
                </Typography>

                <Button
                  fullWidth
                  variant="contained"
                  startIcon={<img src={googleIcon} alt="Google" style={{ width: 18 }} />}
                  onClick={handleGoogleLogin}
                  sx={{
                    bgcolor: '#0052ff',
                    color: '#fff',
                    py: 1.2,
                    fontWeight: 500,
                    borderRadius: 2,
                    textTransform: 'none',
                    mb: 0.5
                  }}
                >
                  Google
                </Button>

                <Divider
                  sx={{
                    my: 1,
                    '&::before, &::after': { borderColor: '#ccc' },
                    color: '#536686',
                    fontSize: '13px'
                  }}
                >
                  Or
                </Divider>

                <Button
                  fullWidth
                  variant="contained"
                  startIcon={<Phone sx={{ width: 18, height: 18, color: '#fff' }} />}
                  onClick={handleToggleLoginMethod}
                  sx={{
                    bgcolor: '#0052ff',
                    color: '#fff',
                    py: 1.2,
                    fontWeight: 500,
                    borderRadius: 2,
                    textTransform: 'none'
                  }}
                >
                  Phone Number
                </Button>
              </Box>

              {/* Don't have an account - Bordered Box replacing Divider */}
              <Box
                sx={{
                  border: '1px solid #ccc',
                  borderRadius: 2,
                  p: 2,
                  my: 2,
                  position: 'relative'
                }}
              >
                <Typography
                  sx={{
                    position: 'absolute',
                    top: -12,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    bgcolor: '#fff',
                    px: 2,
                    color: '#536686',
                    fontSize: '13px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Don't have an account, Signup
                </Typography>

                <Button
                  fullWidth
                  variant="outlined"
                  startIcon={<Person sx={{ width: 18, height: 18, color: '#536686' }} />}
                  onClick={() => navigate('/register')}
                  sx={{
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 500,
                    pt: 1.2,
                    pb: 1.2,
                    fontSize: '0.9rem',
                    borderColor: '#536686',
                    color: '#536686',
                    '&:hover': {
                      borderColor: '#0052ff',
                      backgroundColor: 'rgba(0, 82, 255, 0.04)'
                    }
                  }}
                >
                  Create an Account
                </Button>
              </Box>
            </>
          ) : (
            <>
              {/* PHONE LOGIN VIEW */}
              <Typography variant="subtitle2" sx={{ mb: 0.5 }}>Phone Number</Typography>
              <TextField
                fullWidth
                placeholder="Enter your phone number"
                margin="dense"
                value={phoneNumber}
                onChange={handlePhoneNumberChange}
                disabled={showOtpInput}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px', } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Phone sx={{ width: 18, height: 18, mr: 1, color: '#536686' }} />
                    </InputAdornment>
                  ),
                }}
                inputProps={{ maxLength: 10, pattern: '[0-9]*' }}
              />

              {showOtpInput && (
                <>
                  <Typography variant="subtitle2" sx={{ mt: 1.5, mb: 0.5 }}>OTP</Typography>
                  <TextField
                    fullWidth
                    placeholder="Enter OTP"
                    margin="dense"
                    value={otp}
                    onChange={handleOtpChange}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px', } }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <img src={lockIcon} alt="lock" style={{ width: 18, marginRight: 10 }} />
                        </InputAdornment>
                      ),
                    }}
                    inputProps={{ maxLength: 6, pattern: '[0-9]*' }}
                  />
                </>
              )}

              <Box display="flex" justifyContent="space-between" alignItems="center" mt={1.5} mb={2} flexWrap="wrap">
                <FormControlLabel
                  control={<Checkbox size="small" />}
                  label="Remember me"
                  sx={{ '& .MuiFormControlLabel-label': { color: '#536686', fontSize: { xs: '12px', sm: '13px' } }, }}
                />
                {showOtpInput && (
                  <Typography
                    component="span"
                    onClick={handleGetOTP}
                    sx={{ fontSize: { xs: '12px', sm: '13px' }, color: '#0052ff', textDecoration: 'none', cursor: 'pointer' }}
                  >
                    Resend OTP
                  </Typography>
                )}
              </Box>

              <Button
                variant="contained"
                fullWidth
                disabled={loading || (showOtpInput ? otp.length < 4 : phoneNumber.length !== 10)}
                onClick={showOtpInput ? handleVerifyOtp : handleGetOTP}
                sx={{ bgcolor: '#0052ff', color: '#fff', py: 1.2, fontWeight: 500, borderRadius: 2, textTransform: 'none', mb: 2 }}
              >
                {showOtpInput ? 'Login with OTP' : 'Get OTP'}
              </Button>

              <Divider
                sx={{ my: 2, '&::before, &::after': { borderColor: '#ccc' }, color: '#536686', fontSize: '13px' }}
              >
                Or connect with
              </Divider>

              <Button
                fullWidth
                variant="outlined"
                startIcon={<img src={googleIcon} alt="Google" style={{ width: 18 }} />}
                onClick={handleToggleLoginMethod}
                sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 500, pt: 1.2, pb: 1.2, fontSize: '0.9rem' }}
              >
                Google
              </Button>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Login;

